document.addEventListener("alpine:init", () => {
  Alpine.data("productSearch", (apiUrl = "/wp-json/v1/product-search") => ({
    query: "",
    results: [],
    isLoading: false,
    isOpen: false,
    abortController: null,
    init() {
      // ON "/" event listener
      document.addEventListener("keydown", (event) => {
        if (event.key === "/") {
          document.querySelector("#product-search-input").focus();
          event.preventDefault();
        }
      });
      this.$watch("query", () => {
        this.performSearch();
      });
    },

    async performSearch() {
      console.log(this.query);
      if (this.query.length == 0) {
        this.results = [];
        this.isOpen = false;
        this.isLoading = false;
        return;
      }

      this.isLoading = true;
      this.isOpen = true;

      // Laufenden Request abbrechen, falls user weitertippt
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      try {
        // Parameter an die URL hängen
        const url = new URL(window.location.origin + apiUrl);
        url.searchParams.append("term", this.query);

        const response = await fetch(url, {
          signal: this.abortController.signal,
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) throw new Error("Network error");

        this.results = await response.json();
      } catch (error) {
        // AbortError ignorieren wir (das ist gewollt)
        if (error.name !== "AbortError") {
          console.error("Search error:", error);
          this.results = [];
        }
      } finally {
        // Loading nur stoppen, wenn dieser Request nicht abgebrochen wurde
        if (this.abortController && !this.abortController.signal.aborted) {
          this.isLoading = false;
        }
      }
    },

    // Helper für UX
    close() {
      this.isOpen = false;
    },
  }));
});
